import React from 'react';
import DataTableActionMenu from '../../../Elements/DataTable/DataTableActionMenu';
import LongText from '../../../Elements/LongText';
import TabbedPage from '../../../Elements/TabbedPage';
import TabListTableCellWidthEnum from '../../../Enums/TabListTableCellWidthEnum';
import TpWaveAdmin from '../../../Contents/ThirdParty/TpWave/TpWaveAdmin';
import FieldTypesEnum from '../../../Enums/FieldTypesEnum';
import ClientFeesComponent from '../../../Elements/ClientFeesComponent';
import TpSurveyAdmin from '../../../Contents/ThirdParty/TpSurvey/TpSurveyAdmin';
import UninvoiceableTpJobAdmin from '../../../Contents/Operations/TpJob/UninvoiceableTpJobAdmin';
import ExcludedTpJobsAdmin from '../../../Contents/Operations/TpJob/ExcludedTpJobsAdmin';
import AllTpJobsAdmin from '../../../Contents/Operations/TpJob/AllTpJobsAdmin';
import userHelper from '../../../Helpers/userHelper';
import JsxHelper from '../../../Helpers/JsxHelper';
import InvoiceAutomationStatusChip from '../../../Contents/ThirdParty/Project/InvoiceAutomation/InvoiceAutomationStatusChip.tsx';
import InvoiceAutomationSetupPage from '../../../Contents/ThirdParty/Project/InvoiceAutomation/InvoiceAutomationSetupPage.tsx';
import InvoiceAutomationReadyForInvoicing from '../../../Contents/ThirdParty/Project/InvoiceAutomation/InvoiceAutomationReadyForInvoicing.tsx';

export default class NewProjectItem {
  constructor(item) {
    if (item === undefined) {
      this.ProjectId = '';
      this.ProjectName = '';
      this.ClientName = '';
      this.StartDate = '';
      this.EndDate = '';
      this.OfficeName = '';
      this.ServiceType = '';
      this.ProjectManagerName = '';
      this.OpportunityId = '';
      this.OpportunityName = '';
      this.ServiceId = '';
      this.ServiceName = '';
      this.BillingCurrency = '';
      this.Contact = '';
      //this.ReimbursementType = '';
      this.ShopCountInCycle = '';
      this.Comments = '';
      this.ContactId = '';
      this.ProjectManagerUserId = '';
      this.BravoClientId = '';
      this.IsWaveLinkingEnabled = false;
      this.BravoClintIdAndName = '';
      this.IgnoreExpensesForClientInvoice = false;
      this.HasOutsourcedProcessing = false;
      this.OutsourcingOfficeIds = [];
      this.OutsourcingOfficeNames = [];
      this.IsPrismProject = false;
      this.PlatformCostOverrideAmountUsd = '';
      this.PlatformCostOverrideEffectiveFromDate = '';
      this.PlatformCostOverrideEndDate = '';
      this.InvoiceAutomationIsActive = null;
      this.InvoiceAutomationRunSchedule = null;
      this.InvoiceAutomationInvoicedWithProjectId = null;
      this.InvoiceAutomationInvoicedWithProjectName = null;
      return;
    }

    this.ProjectId = item.projectId;
    this.ProjectName = item.projectName;
    this.ClientName = item.clientName;
    this.StartDate = item.startDate;
    this.EndDate = item.endDate;
    this.OfficeName = item.officeName;
    this.ServiceType = item.serviceType;
    this.ProjectManagerName = item.projectManagerName;
    this.OpportunityId = item.opportunityId;
    this.OpportunityName = item.opportunityName;
    this.OpportunityDisplayName = `${item.opportunityId} - ${item.opportunityName}`;
    this.ServiceId = item.serviceId;
    this.ServiceName = item.serviceName;
    this.ServiceDisplayName = `${item.serviceId} - ${item.serviceName}`;
    this.BillingCurrency = item.billingCurrency;
    this.Contact = item.contact;
    //this.ReimbursementType = item.reimbursementType;
    this.ShopCountInCycle = item.shopCountInCycle;
    this.Comments = item.comments;
    this.ContactId = item.contactId;
    this.ProjectManagerUserId = item.projectManagerUserId;
    this.BravoClientId = item.bravoClientId;
    this.IsWaveLinkingEnabled = item.isWaveLinkingEnabled;
    this.BravoClintIdAndName = `${item.bravoClientId} - ${item.clientName}`;
    this.IgnoreExpensesForClientInvoice = item.ignoreExpensesForClientInvoice;
    this.HasOutsourcedProcessing = item.hasOutsourcedProcessing ?? false;
    this.OutsourcingOfficeIds = item.outsourcingOfficeIds || [];
    this.OutsourcingOfficeNames = item.outsourcingOfficeNames || [];
    this.IsPrismProject = item.isPrismProject;
    this.PlatformCostOverrideAmountUsd = item.platformCostOverrideAmountUsd;
    this.PlatformCostOverrideEffectiveFromDate = item.platformCostOverrideEffectiveFromDate;
    this.PlatformCostOverrideEndDate = item.platformCostOverrideEndDate;
    // Both null when no automatic invoicing setup invoices the project's jobs. For a project on another setup's
    // invoice they are that setup's, and InvoicedWithProject names the setup's project.
    this.InvoiceAutomationIsActive = item.invoiceAutomationIsActive;
    this.InvoiceAutomationRunSchedule = item.invoiceAutomationRunSchedule;
    this.InvoiceAutomationInvoicedWithProjectId = item.invoiceAutomationInvoicedWithProjectId ?? null;
    this.InvoiceAutomationInvoicedWithProjectName = item.invoiceAutomationInvoicedWithProjectName ?? null;
  }

  static getPlatformCostOverrideText(item) {
    if (!item.PlatformCostOverrideAmountUsd) {
      return '-';
    }
    const from = (item.PlatformCostOverrideEffectiveFromDate ?? '').substring(0, 7);
    const until = item.PlatformCostOverrideEndDate ? `until ${item.PlatformCostOverrideEndDate}` : '(open-ended)';
    return `${item.PlatformCostOverrideAmountUsd} USD from ${from} ${until}`;
  }

  static getInvoiceAutomationStatus(item) {
    return (
      <InvoiceAutomationStatusChip
        isActive={item.InvoiceAutomationIsActive}
        runSchedule={item.InvoiceAutomationRunSchedule}
        invoicedWithProjectId={item.InvoiceAutomationInvoicedWithProjectId}
        invoicedWithProjectName={item.InvoiceAutomationInvoicedWithProjectName}
      />
    );
  }

  static displayedInList = 'Name';

  static NameOfTheIdField() {
    return 'ProjectId';
  }

  static nameOfTheItemDetailList() {
    return 'Project';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateOnlyFields = ['StartDate', 'EndDate'];

  static DateFields = ['StartDate', 'EndDate'];

  static BoolFields = [];

  static nameOfTheItemDetailList(item) {
    if (item)
      return (
        <span>
          Project Details -{' '}
          <LongText
            text={`${item.ClientName} - ${item.ProjectName} (${item.ProjectId})`}
            maxLength={40}
          />
        </span>
      );
    return 'Project Details';
  }

  static toggleWaveLinking = (item) => {
    alert('Toggle Wave Linking function');
  };

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: item.IsWaveLinkingEnabled ? 'fa-solid fa-trash-can' : 'fa-solid fa-link',
            text: item.IsWaveLinkingEnabled ? 'Deactivate Wave Linking' : 'Activate Wave Linking',
            onClick: () => NewProjectItem.toggleWaveLinking(item),
            roleKey: 'project_edit',
            hide: !userHelper.isAdmin(),
          },
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            onClick: () => NewProjectItem.editFunction(item.ProjectId, item),
            roleKey: 'project_edit',
          },
          {
            iconName: 'fa-solid fa-money-check-dollar',
            text: 'Platform Cost Override',
            onClick: () => NewProjectItem.platformCostOverrideFunction(item),
            roleKey: 'project_edit',
            hide: !item.IsPrismProject,
          },
          {
            iconName: 'fa-solid fa-file-invoice',
            text: 'Automatic Invoicing',
            onClick: () => NewProjectItem.invoiceAutomationFunction(item),
            roleKey: 'invoice_automation_edit',
          },
          {
            iconName: 'fa-solid fa-play',
            text: 'Run Automatic Invoicing Now',
            onClick: () => NewProjectItem.runInvoiceAutomationFunction(item),
            roleKey: 'invoice_automation_edit',
            // Its own Active setup only: a project on another setup's invoice is run from that setup's project.
            hide: item.InvoiceAutomationIsActive !== true || item.InvoiceAutomationInvoicedWithProjectId != null,
          },
        ]}
      />
    );
  }

  static editFunction = (id, item, itemList) => {
    alert('Empty function');
  };

  static platformCostOverrideFunction = (item) => {
    alert('Empty function');
  };

  static invoiceAutomationFunction = (item) => {
    alert('Empty function');
  };

  // The tabName of the project popup's Automatic Invoicing tab, which its row action opens on.
  static invoiceAutomationTabName = 'Automatic Invoicing';

  static runInvoiceAutomationFunction = (item) => {
    alert('Empty function');
  };

  // Called by the Automatic Invoicing tab when it saved or switched the setup, so that the list loads again.
  static invoiceAutomationChangedFunction = () => {};

  // The Automatic Invoicing tab saved or switched the setup (savedSetup, an InvoiceAutomationItem): the project shown
  // in the popup takes the new status, so that its General tab and its Ready for Invoicing banner show it as soon as
  // they are opened, and the list loads again when the popup closes.
  static applyInvoiceAutomationChange(item, savedSetup) {
    item.InvoiceAutomationIsActive = savedSetup.IsActive;
    item.InvoiceAutomationRunSchedule = savedSetup.RunSchedule;
    NewProjectItem.invoiceAutomationChangedFunction();
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Project ID',
        orderById: 'ProjectId',
        data: 'ProjectId',
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      { label: 'Client', orderById: 'ClientName', data: 'ClientName' },
      { label: 'Project', orderById: 'ProjectName', data: 'ProjectName' },
      { label: 'Start Date', orderById: 'StartDate', data: 'StartDate' },
      { label: 'End Date', orderById: 'EndDate', data: 'EndDate' },
      { label: 'Office', orderById: 'OfficeName', data: 'OfficeName' },
      { label: 'Service Type', orderById: 'ServiceType', data: 'ServiceType' },
      { label: 'Project Manager', orderById: 'ProjectManagerName', data: 'ProjectManagerName' },
      { label: 'Automatic Invoicing', orderById: '', data: NewProjectItem.getInvoiceAutomationStatus },
      {
        label: ' ',
        orderById: 'ProjectId',
        data: NewProjectItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static getClientFeeContent(item) {
    return (
      <ClientFeesComponent
        searchItem={{ CfServiceId: item.ServiceId }}
        serviceId={item.ServiceId}
      />
    );
  }

  static getTpSurveysContent(item) {
    return <TpSurveyAdmin ProjectId={item.ProjectId} />;
  }

  static getTpJobsContent(item) {
    const tabs = [
      {
        label: 'Ready for Invoicing',
        id: 'finalized',
        icon: 'fa-solid fa-monument',
        component: <InvoiceAutomationReadyForInvoicing project={item} />,
      },
      {
        label: 'Uninvoiceable',
        id: 'uninvoicable',
        icon: 'fa-solid fa-monument',
        component: (
          <UninvoiceableTpJobAdmin
            ProjectId={item.ProjectId}
            SearchType='uninvoiceable'
          />
        ),
      },
      {
        label: 'Excluded Pay Evaluators',
        id: 'excluded',
        icon: 'fa-solid fa-monument',
        component: (
          <ExcludedTpJobsAdmin
            ProjectId={item.ProjectId}
            SearchType='excluded'
          />
        ),
      },
      {
        label: 'All Third-Party Jobs',
        id: 'all',
        icon: 'fa-solid fa-monument',
        component: (
          <AllTpJobsAdmin
            ProjectId={item.ProjectId}
            SearchType='all'
          />
        ),
      },
    ];
    return (
      <TabbedPage
        tabs={tabs}
        className='border rounded opacity70'
      />
    );
  }

  static getTpWavesContent(item) {
    return <TpWaveAdmin ProjectId={item.ProjectId} />;
  }

  static getInvoiceAutomationContent(item) {
    return (
      <InvoiceAutomationSetupPage
        project={item}
        onSetupChange={(savedSetup) => NewProjectItem.applyInvoiceAutomationChange(item, savedSetup)}
      />
    );
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'ProjectId', label: 'Project ID' },
        { name: 'OpportunityDisplayName', label: 'Opportunity' },
        { name: 'OfficeName', label: 'Office' },
        { name: 'ProjectName', label: 'Project Name' },
        { name: 'ServiceDisplayName', label: 'Service' },
        { name: 'BravoClintIdAndName', label: 'Client' },
        { name: 'ServiceType', label: 'Service Type' },
        { name: 'BillingCurrency', label: 'BillingCurrency' },
        { name: 'Contact', label: 'Contact' },
        //{ name: 'ReimbursementType', label: 'Reimbursement Type' },
        { name: 'ShopCountInCycle', label: 'Shop Count In Cycle' },
        { name: 'ProjectManagerName', label: 'Project Manager' },
        { name: 'StartDate', label: 'Start Date' },
        { name: 'EndDate', label: 'End Date' },
        {
          name: (item) => JsxHelper.YesNo(item.IgnoreExpensesForClientInvoice),
          label: 'Ignore Expenses For Client Invoice?',
        },
        {
          name: (item) => NewProjectItem.getPlatformCostOverrideText(item),
          label: 'Platform Cost Override',
          hidden: (item) => !item.PlatformCostOverrideAmountUsd,
        },
        {
          name: NewProjectItem.getInvoiceAutomationStatus,
          label: 'Automatic Invoicing',
          hidden: (item) => item.InvoiceAutomationIsActive == null,
        },
        {
          name: (item) => JsxHelper.YesNo(item.HasOutsourcedProcessing),
          label: 'Outsourced Processing?',
        },
        { name: (item) => item.OutsourcingOfficeNames?.join(', '), label: 'Work outsourced to' },
        { name: 'Comments', label: 'Project Summary', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    {
      tabName: 'Client Fees',
      tabLabel: 'Client Fees',
      icon: 'fa-solid fa-coins',
      data: [
        { name: NewProjectItem.getClientFeeContent, label: 'Client Fees', width: TabListTableCellWidthEnum.Table },
      ],
    },
    {
      tabName: 'Third-Party Surveys',
      tabLabel: 'Third-Party Surveys',
      icon: 'fa-brands fa-grav fa',
      data: [
        {
          name: NewProjectItem.getTpSurveysContent,
          label: 'Third-Party Surveys',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'Third-Party Jobs',
      tabLabel: 'Third-Party Jobs',
      icon: 'fa-brands fa-grav fa',
      data: [
        {
          name: NewProjectItem.getTpJobsContent,
          label: 'Third-Party Jobs',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: NewProjectItem.invoiceAutomationTabName,
      tabLabel: 'Automatic Invoicing',
      icon: 'fa-solid fa-file-invoice',
      rolekey: 'invoice_automation_view',
      data: [
        {
          name: NewProjectItem.getInvoiceAutomationContent,
          label: 'Automatic Invoicing',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'Third-Party Waves',
      tabLabel: 'Third-Party Waves',
      icon: 'fa-brands fa-grav fa',
      hidden: (item) => !item.IsWaveLinkingEnabled,
      data: [
        {
          name: NewProjectItem.getTpWavesContent,
          label: 'Third-Party Waves',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
  ];
}
